"use strict";

import Dropdown from 'bootstrap/js/dist/dropdown';

export function init() {
    const dropdownElementList = [].slice.call(document.querySelectorAll('[data-bs-toggle="dropdown"]'))
    const dropdownList = dropdownElementList.map(function (dropdownTriggerEl) {
        return new Dropdown(dropdownTriggerEl);
    })
}